import State from 'interfaces/state/State';

export const currentTab$ = (state: State): number => state.tab.currentTab;
